import { setAuthToken, resetAuthToken } from '@plugins/api';
import Auth from '@services/Utilities/Auth';

export default {
  async login({ dispatch }, data) {
    try {
      let response = await Auth.login(data);
      const tokenData = response.data;
      dispatch('setUser', tokenData.user);
      setAuthToken(tokenData.api_token.access_token);
      return response;
    } catch (error) {
      throw error;
    }
  },
  async logout(context) {
    try {
      let response = await Auth.logout();
      context.commit('logout');
      return response;
    } catch (error) {
      throw error;
    } finally {
      resetAuthToken();
    }
  },
  async fetchUser({ dispatch }) {
    try {
      let response = await Auth.fetchSelf();
      dispatch('setUser', response.data);
      return response;
    } catch (error) {
      resetAuthToken();
      return false;
    }
  },
  setUser(context, payload) {
    context.commit('setUser', payload);
  },
  changeBalance(context, balance) {
    context.commit('changeBalance', balance);
  },
};
